import { useEffect, useState } from 'react'

const useLoadDailyKarma = () => {
  const [hasLoaded, setHasLoaded] = useState(false)
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!hasLoaded && typeof window !== 'undefined') {
        const script = document.createElement('script')
        script.src = 'https://assets.dailykarma.io/prod/chord/init.js'
        document.head.appendChild(script)
        setHasLoaded(true)
      }
    }, 10000)
    return () => clearTimeout(timeout)
  }, [])
  return { hasLoaded }
}

export default useLoadDailyKarma
